import React, { useEffect } from 'react';
import { Grid } from '@mui/material';

import Banner from '../../components/banner';
import Enrich from '../../components/enrich';
import FootPrint from '../../components/footprint';
import Leading from '../../components/leading';
import GetKnow from '../../components/getKnow';
import GetusKnow from '../../components/getus';
import Clients from '../../components/clients';

const Home = () => {

    useEffect(() => {
        window.scrollTo({top:0, left:0})
    }, [])


    return (
        <Grid container style={{width:'100%', justifyContent:'center'}}>
            <Grid item xs={12} sx={{width:'100'}} >
            <Grid style={{backgroundColor:'#F4F8FA', width:'100%', display:'flex', justifyContent:'center'}}>
                <Banner />
            </Grid>
            <Enrich />
            <FootPrint title='Our footprint' content='At Unique Engineers, we believe buildings should not just serve today’s needs, they should be ready for tomorrow. That is why our solutions focus on long-term performance. We use smart controls, efficient layouts, and high-quality materials that stand the test of time.
Being one of the top MEP consultants in Gurgaon means staying current with new technologies and evolving standards. We are always learning. And we bring that knowledge to every project.' />
            <Leading />
            <GetKnow />
            <GetusKnow />
            <Clients />
        </Grid>
        </Grid>
    )

}

export default Home;